export default {
  conServer: 'https://conf.geekbang.org'
}
